const TRANSLATION = {
  common: {
    loading: 'लोड हो रहा है',
  },
  i18n: {
    English: 'अंग्रेज़ी',
    Spanish: 'स्पेनिश',
    Russian: 'रूसी',
    'Portuguese (Brazil)': 'पुर्तगाली (ब्राज़ील)',
    Indonesian: 'इंडोनेशियाई',
    Czech: 'चेक',
    German: 'जर्मन',
    French: 'फ्रेंच',
    Italian: 'इतालवी',
    Dutch: 'डच',
    Polish: 'पोलिश',
    Vietnamese: 'वियतनामी',
    Turkish: 'तुर्की',
    Ukrainian: 'यूक्रेनी',
    Chinese: 'सरलीकृत चीनी',
    'Traditional Chinese': 'चीनी पारंपरिक',
    Japanese: 'जापानी',
    Korean: 'कोरियाई',
    Arabic: 'अरबी',
    Persian: 'फारसी',
    Thai: 'थाई',
    Hindi: 'हिंदी',
    Malay: 'मलया',
    province: {
      Hebei: 'हेबेई प्रांत',
      Shanxi: 'शांक्सी प्रांत',
      Liaoning: 'लिओनिंग प्रांत',
      Jilin: 'जीलिन प्रांत',
      Heilongjiang: 'हेलोंगजियांग प्रांत',
      Jiangsu: 'जिआंग्सु प्रांत',
      Zhejiang: 'झेजियांग प्रांत',
      Anhui: 'आनहुई प्रांत',
      Fujian: 'फुजियान प्रांत',
      Jiangxi: 'जिआंग्शी प्रांत',
      Shandong: 'शानदोंग प्रांत',
      Henan: 'हेनान प्रांत',
      Hubei: 'हूबेई प्रांत',
      Hunan: 'हूनान प्रांत',
      Guangdong: 'ग्वांगडोंग प्रांत',
      Hainan: 'हैनान प्रांत',
      Sichuan: 'सिचुआन प्रांत',
      Guizhou: 'गुइझोउ प्रांत',
      Yunan: 'युन्नान प्रांत',
      Shaanxi: 'शांक्सी प्रांत (उत्तर पश्चिम)',
      Gansu: 'गांसु प्रांत',
      Qinghai: 'छींगहाई प्रांत',
      Taiwan: 'ताइवान प्रांत',
      Guangxi: 'गुआंग्शी झुआंग स्वायत्त क्षेत्र',
      Neimenggu: 'आंतरिक मंगोलिया स्वायत्त क्षेत्र',
      Tibet: 'तिब्बत स्वायत्त क्षेत्र',
      Ningxia: 'निंगशिया हूई स्वायत्त क्षेत्र',
      Xinjiang: 'शिनजियांग वीगुर स्वायत्त क्षेत्र',
      HongKong: 'हांगकांग विशेष प्रशासनिक क्षेत्र',
      Macau: 'मकाओ विशेष प्रशासनिक क्षेत्र',
      Beijing: 'बीजिंग नगरपालिका',
      Tianjin: 'थ्यांजिन नगरपालिका',
      Shanghai: 'शंघाई नगरपालिका',
      Chongqing: 'चोंगचिंग नगरपालिका',
    },
  },
  pageHeader: {
    product: 'उत्पाद',
    tvcTest: 'TVC अनुभव परीक्षण',
    tvcEval: 'TVC सृजनात्मक मूल्यांकन',
    contactUs: 'संपर्क करें',
    Pricing: 'मूल्य निर्धारण',
    Dashboard: 'अभी शुरू करें',
    signIn: 'साइन इन करें',
    signUp: 'साइन अप करें',
    resourceCenter: 'ब्लॉग',
    all: 'सभी',
    news: 'समाचार',
    insight: 'दृष्टि',
    case: 'उदाहरण',
  },
  productSwitch: {
    common: {
      comingSoon: 'जल्द आ रहा है',
    },
    modal: {
      heroTitle: 'कृपया वह परीक्षण चुनें जिसे आप चलाना चाहते हैं',
      heroSubtitle:
        'AdEff जब भी आपको आवश्यकता हो, बहुआयामी क्रिएटिव इनसाइट प्रदान करने के लिए तैयार है।',
      remainingTimes: 'शेष बार: {{count}}',
      supportedAssets: 'समर्थित एसेट',
      coreMetrics: 'मुख्य मीट्रिक',
      cognitiveNeuroscienceIndicators: 'कॉग्निटिव-न्यूरल संकेतक',
      consumerAttitudeIndicators: 'उपभोक्ता दृष्टिकोण संकेतक',
      outputResult: 'आउटपुट परिणाम',
      dataReport: 'डेटा रिपोर्ट',
      analysisReport: 'विश्लेषण रिपोर्ट',
      accessBackend: 'अभी शुरू करें',
      tabs: {
        tvc: 'क्षैतिज क्रिएटिव परीक्षण',
        portrait: 'वर्टिकल क्रिएटिव परीक्षण',
      },
      cards: {
        tvcQuick: {
          title: 'क्षैतिज-त्वरित परीक्षण',
          descriptionHighlight:
            'डेटा-समर्थित निर्णयों के लिए क्रिएटिव का तेजी से मूल्यांकन करें',
        },
        tvcBase: {
          title: 'हॉरिज़ॉन्टल-क्रिएटिव डायग्नोसिस',
          descriptionHighlight:
            'क्रिएटिव विवरणों को बारीकी से निखारें और लागू करने योग्य संशोधन सुझाव पाएं',
          value1: '10–60 सेकंड TVC/OTV क्रिएटिव',
          value2: 'कॉग्निटिव-न्यूरल संकेतक',
        },
        tvcSurvey: {
          title: 'हॉरिज़ॉन्टल-इनसाइटPro',
          descriptionHighlight:
            'रणनीतिक ऑप्टिमाइज़ेशन मार्गदर्शन के साथ बहुआयामी क्रिएटिव विश्लेषण',
          value1: '10–60 सेकंड TVC/OTV क्रिएटिव',
          value2: 'कॉग्निटिव-न्यूरल संकेतक',
        },
        portraitQuick: {
          title: 'लंबवत-त्वरित परीक्षण',
          descriptionHighlight:
            'डेटा-समर्थित निर्णयों के लिए क्रिएटिव का तेजी से मूल्यांकन करें',
        },
        portraitBase: {
          title: 'वर्टिकल-क्रिएटिव डायग्नोसिस',
          descriptionHighlight:
            'क्रिएटिव विवरणों को बारीकी से निखारें और लागू करने योग्य संशोधन सुझाव पाएं',
          value1: '5–90 सेकंड के वर्टिकल क्रिएटिव',
          value2: 'कॉग्निटिव-न्यूरल संकेतक',
        },
        portraitSurvey: {
          title: 'वर्टिकल-इनसाइटPro',
          descriptionHighlight:
            'रणनीतिक ऑप्टिमाइज़ेशन मार्गदर्शन के साथ बहुआयामी क्रिएटिव विश्लेषण',
          value1: '5–90 सेकंड के वर्टिकल क्रिएटिव',
          value2: 'कॉग्निटिव-न्यूरल संकेतक',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: 'हॉरिज़ॉन्टल क्रिएटिव टेस्ट',
          assetText: '10-60 सेकंड TVC/OTV क्रिएटिव के लिए',
        },
        portrait: {
          bannerTitle: 'वर्टिकल क्रिएटिव टेस्ट',
          assetText: '5-90 सेकंड वर्टिकल क्रिएटिव के लिए',
        },
      },
      items: {
        tvcQuick: {
          description: 'क्रिएटिव्स की तुरंत तुलना करें और निर्णय लें',
        },
        tvcBase: {
          title: 'क्रिएटिव डायग्नोसिस',
          description: 'सेकंड-दर-सेकंड ऑप्टिमाइज़ेशन, क्रिएटिव को निखारें',
        },
        tvcSurvey: {
          title: 'डीप इनसाइट',
          description: 'व्यापक विश्लेषण, समस्या की सटीक पहचान',
        },
        portraitBase: {
          title: 'क्रिएटिव डायग्नोसिस',
          description: 'सेकंड-दर-सेकंड ऑप्टिमाइज़ेशन, क्रिएटिव को निखारें',
        },
        portraitQuick: {
          description: 'क्रिएटिव्स की तुरंत तुलना करें और निर्णय लें',
        },
        portraitSurvey: {
          title: 'डीप इनसाइट',
          description: 'व्यापक विश्लेषण, समस्या की सटीक पहचान',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: 'हम कुकीज़ का उपयोग करते हैं',
    desc: 'हमारी वेबसाइट को सही तरीके से चलाने के लिए आवश्यक कुकीज़ का उपयोग करते हैं। आपकी सहमति से, हम आपके अनुभव को बेहतर बनाने के लिए विश्लेषणात्मक कुकीज़ का भी उपयोग करते हैं। हमारी गोपनीयता नीति में हमारी कुकी नीति देखें।',
    btn1: 'सभी अस्वीकार करें',
    btn2: 'सभी स्वीकार करें',
    cookiePolicy: 'कुकी नीति',
  },
  landing: {
    banner: {
      text1: 'एआई संचालित',
      text2: 'विज्ञापन',
      text3: 'परीक्षण',
      text4: 'सृजनात्मकता परीक्षण और अनुकूलन मंच',
      feature1: 'सामग्री का डिकोडिंग',
      feature2: 'प्रतिक्रिया की भविष्यवाणी',
      feature3: 'डेटा एकीकरण',
      feature4: 'निष्कर्ष और सिफारिशें',
      btn1: 'डेमो प्राप्त करें',
      btn2: 'प्रोजेक्ट बनाएं',
    },
    info: {
      title:
        'मल्टी-मॉडल बड़े भाषा मॉडल (HMLLM)* के आधार पर, सृजनात्मकता की प्रभावशीलता की भविष्यवाणी को तेजी से लागू करें और विज्ञापन पर निवेश पर रिटर्न बढ़ाएं',
      subTitle: '*यह मॉडल कई न्यूरो मार्केटिंग परीक्षणों और मल्टी-एजेंट निर्माण पर आधारित है',
      detail1: 'तेजी से विज्ञापन परीक्षण',
      detail1Desc:
        'AdEff 15 मिनट में लक्षित दर्शकों का ध्यान, भावनात्मक उतार-चढ़ाव और सृजनात्मक सामग्री में भागीदारी प्राप्त कर सकता है, और विस्तृत रिपोर्ट और अनुकूलन मार्गदर्शन प्रदान कर सकता है।',
      detail2: 'सर्वश्रेष्ठ सृजनात्मकता का तेजी से चयन',
      detail2Desc:
        'AdEff एक साथ कई सृजनात्मकताओं को मापने का समर्थन करता है, जिससे ब्रांडों को तेजी से निर्णय लेने में मदद मिलती है। और विस्तृत तुलना विश्लेषण प्रदान करता है।',
      detail3: 'एक-क्लिक संपादन, विविध प्रभावी संस्करण उत्पन्न करना',
      detail3Desc:
        'AdEff एक-क्लिक संपादन का समर्थन करता है, जिससे तेजी से विविध प्रभावी संस्करण उत्पन्न होते हैं, जो विभिन्न प्रसार परिदृश्यों के लिए उपयुक्त होते हैं।',
    },
    advantages: {
      title: 'AdEff के लाभ',
      item1Title: 'तेजी से प्रतिक्रिया',
      item1Desc: 'सबसे तेज़ <tmp>15 मिनट</tmp> में रिपोर्ट प्राप्त करें।',
      item2Title: 'विशिष्ट एआई मॉडल',
      item2Desc: 'दर्शकों की प्रतिक्रिया पर आधारित अद्वितीय <tmp>एआई मॉडल</tmp>।',
      item3Title: 'दृश्यात्मक ग्राफ़',
      item3Desc: '<tmp>दृश्यात्मक ग्राफ़</tmp> + एआई व्याख्या, एक-क्लिक में परीक्षण रिपोर्ट',
      item4Title: 'विशाल डेटा रेंज',
      item4Desc: '<tmp>50,000+</tmp> सृजनात्मकता डेटाबेस',
      item5Title: 'विशेषज्ञों की टीम',
      item5Desc: '<tmp>विशेषज्ञों की टीम</tmp> समर्थन और मार्गदर्शन प्रदान करती है',
    },
    service: {
      title: 'AdEff सेवा के तरीके',
      desc: 'आपको आवश्यक सेवा का तरीका चुनें',
      topTitle: 'ऑनलाइन आत्म-सेवा',
      topRow1: 'स्वतंत्र रूप से प्रोजेक्ट बनाएं और परीक्षण पूरा करें',
      topRow2: 'दृश्यात्मक ग्राफ़ + एआई व्याख्या रिपोर्ट',
      topRow3: 'वस्तुनिष्ठ न्यूरोसाइंस माप (आंखों की गति + ईईजी)',
      topRow4: 'विशिष्ट एआई मॉडल परीक्षण',
      bottomTitle: 'विशेषज्ञों की टीम की सेवाएं',
      bottomRow1: 'विशेषज्ञों द्वारा प्रोजेक्ट बनाना और परीक्षण पूरा करना',
      bottomRow2:
        'वस्तुनिष्ठ न्यूरोसाइंस माप (आंखों की गति + ईईजी), वैकल्पिक रूप से विषयगत माप जोड़ना',
      bottomRow3: 'दृश्यात्मक ग्राफ़ + विशेषज्ञ व्याख्या रिपोर्ट',
      bottomRow4: 'विशिष्ट एआई मॉडल परीक्षण, वैकल्पिक रूप से वास्तविक नमूना परीक्षण',
    },
    footer: {
      title:
        'AdEff मल्टी-मॉडल बड़े भाषा मॉडल (HMLLM) पर आधारित है, दृश्य तत्वों के ईईजी संकेतों और आंखों के ट्रैकिंग डेटा के बीच जटिल संबंधों का निर्माण करके विज्ञापन सृजनात्मकता का त्वरित परीक्षण करता है',
      email: 'ईमेल',
      belongDesc: 'एक उत्पाद <tmp>Mininglamp Technology</tmp>',
    },
    startBtn: 'अभी शुरू करें',
  },
  contact: { title: 'संपर्क करें', copy: 'कॉपी करें', message: { success: 'कॉपी सफल' } },
  pricing: {
    title: 'एआई-चालित क्रिएटिव परीक्षण और अनुकूलन विशेषज्ञ',
    starter: {
      title: 'स्टार्टर',
      desc_1: 'एक बार के परीक्षण के लिए उपयुक्त, खरीदने के तुरंत बाद उपयोग के लिए तैयार',
      desc_2: 'छोटे पैमाने पर परीक्षण के लिए उपयुक्त, खरीदने के तुरंत बाद उपयोग के लिए तैयार',
      timesDesc: '<strong>{{count}}</strong> बार परीक्षण',
      timesDesc1: '<strong>{{count}}</strong> बार परीक्षण',
      discount: '50% छूट',
      originPrice: 'मूल कीमत',
      desc2: 'दर्शकों की प्रतिक्रिया पर आधारित शक्तिशाली एआई मॉडल',
      desc3: 'केवल 15 मिनट में तेज़ प्रतिक्रिया',
      desc4: 'तेज़ और विश्वसनीय अंतर्दृष्टि के लिए उन्नत विश्लेषण',
      desc5: 'तेज़ और विश्वसनीय अंतर्दृष्टि के लिए उन्नत विश्लेषण',
      desc6: 'तेज़ और विश्वसनीय अंतर्दृष्टि के लिए उन्नत विश्लेषण',
      cardDesc1: 'सीमित समय छूट, केवल {{pricePerTest}}',
      cardDesc2: 'टेस्ट कोटा कभी समाप्त नहीं होता',
    },
    premium: {
      time: 'बार',
    },
    unlimited: {
      title: 'अनन्त',
      cardDesc1: '{{pricePerTest}} से शुरू',
      cardDesc2: 'कोटा एक वर्ष के लिए मान्य',
      cardDesc3: 'कस्टम स्वामित्व बेंचमार्क',
      planDesc500: 'पूरे वर्ष में 500 टेस्ट का आनंद लें',
      planDesc1000: 'पूरे वर्ष में 1,000 टेस्ट का आनंद लें',
    },
    benefits: {
      title: 'AdEff क्यों चुनें?',
      subtitle: 'AdEff के साथ, आपको निम्नलिखित लाभ मिलते हैं:',
      expertSupport: 'विशेषज्ञ टीम से सहायता और मार्गदर्शन',
      moreNeedsTitle: 'क्या आपकी अन्य खरीद आवश्यकताएँ हैं?',
      customPlanPrefix: 'हम लचीली और कस्टम योजनाओं का समर्थन करते हैं — हमसे संपर्क करें',
      customPlanSuffix: 'अपने विशेष समाधान के लिए',
    },
    subscribeBtn: 'अभी सदस्यता लें',
    contactUs: 'संपर्क करें',
  },
  login: {
    loginText: 'लॉगिन',
    signUpText: '<tmp>साइन अप करें</tmp> मुफ्त',
    text1: 'सफलतापूर्वक टीम में शामिल हो गया',
    text1Desc: 'आप अभी भी विज्ञापन परीक्षण कर सकते हैं',
    text2: 'उपयोगकर्ता कंपनी में शामिल हो गया',
    text3: 'टीम आमंत्रण समाप्त हो गया',
    text4: 'टीम आमंत्रण लिंक अब मान्य नहीं है।',
    optionText1: 'क्या आपके पास पहले से खाता है?',
    optionText2: 'क्या आपके पास खाता नहीं है?',
    alertText1: 'पंजीकरण करके, मैं सहमत हूं',
    alertText2: 'मैं सहमत हूं',
    termsOfService: 'सेवा की शर्तें',
    privacy: 'गोपनीयता नीति',
    privacyTips: 'कृपया साइन अप करने से पहले सहमति बॉक्स की जाँच करें।',
    and: 'और',
    or: 'या',
    next: 'अगला',
    googleLogin: 'Google के साथ लॉगिन करें',
    googleSignUp: 'Google के साथ साइन अप करें',
    loginWithEmail: 'ईमेल के साथ लॉगिन करें',
    signUpWithEmail: 'ईमेल के साथ साइन अप करें',
    password: 'पासवर्ड',
    emailAddress: 'ईमेल पता',
    enterEmail: 'अपना ईमेल पता दर्ज करें',
    enterPassword: 'अपना पासवर्ड दर्ज करें',
    confirmPassword: 'पासवर्ड की पुष्टि करें',
    forgotPassword: 'पासवर्ड भूल गए?',
    inconsistentPassword: 'पासवर्ड असंगत हैं',
    verificationCode: 'सत्यापन कोड',
    emptyVerificationCode: 'सत्यापन कोड खाली नहीं हो सकता',
    enterVerificationCode: 'सत्यापन कोड दर्ज करें',
    sendedVerificationCode: 'सत्यापन कोड आपके ईमेल पर भेजा गया है',
    emailOrPasswordNotCorrect: 'ईमेल या पासवर्ड गलत है।',
    message: {
      text1: 'अमान्य इनपुट',
      text2: 'ईमेल पहले से पंजीकृत है',
      text3: 'सत्यापन कोड सत्यापन में त्रुटि!',
      text4: 'यह खाता कंपनी से बंधा नहीं है, कृपया फिर से बंधें!',
      text5: 'कृपया सही ईमेल प्रारूप दर्ज करें',
      text6: 'पासवर्ड कम से कम 12 अक्षरों की लंबाई होनी चाहिए',
      text7: 'पासवर्ड में बड़े अक्षर, छोटे अक्षर और संख्याओं का उपयोग करें',
      requestLimit: 'अनुरोध सीमा पार हो गया, कृपया बाद में प्रयास करें',
    },
  },
  resetPwdPage: {
    submit: 'जमा करें',
    emailNotFound: 'कृपया अपना ईमेल जाँचें',
    emailHasSent: 'ईमेल आपके ईमेल पर भेजा गया है {{email}}',
    checkYourInbox: 'आपके ईमेल बॉक्स की जाँच करें',
    resetYourPassword: 'पासवर्ड रीसेट करें',
    resetLinkHasSent: 'एक पासवर्ड रीसेट लिंक आपके खाते से जुड़े ईमेल पर भेजा गया है',
    enterYourEmailAddress: 'आपके ईमेल पता दर्ज करें और हम आपको पासवर्ड रीसेट लिंक भेजेंगे',
    didNotGetEmail: 'ईमेल नहीं मिला?',
    tryAgain: 'फिर से करें',
    goBackToSign: 'लॉगिन पर वापस जाएं',
    email: 'ईमेल',
    enterYourEmail: 'आपके ईमेल पता दर्ज करें',
    resetPassword: 'पासवर्ड रीसेट करें',
    resetPwdSuccess: 'पासवर्ड सफलतापूर्वक रीसेट हो गया है',
    message: {
      resetLinkCodeError: 'लिंक में कोड अमान्य है',
      requestLimit: 'अनुरोध सीमा पार हो गया, कृपया बाद में प्रयास करें',
    },
  },
  memberRequestPage: {
    title: 'सदस्य अनुरोध की पुष्टि करें',
    subTitle: 'अनुरोध से:',
    deny: 'अस्वीकृत करें',
    approve: 'स्वीकृत करें',
    teamFull: 'टीम पूरी है',
    yourTeamIsFull:
      'आपकी टीम पूरी है। आप हमसे अधिक सदस्यों के लिए संपर्क कर सकते हैं या अन्य सदस्यों को हटा सकते हैं।',
    manageMembers: 'AdEff में सदस्यों का प्रबंधन करें',
    requestApproved: 'अनुरोध स्वीकृत',
    approvedDesc:
      'आपने <tmp>{{name}}</tmp> को अपनी टीम में शामिल होने के लिए स्वीकृत किया है, स्वचालित रूप से ईमेल सूचनाएँ भेजी गई हैं।',
    requestDeclined: 'अनुरोध अस्वीकृत',
    declinedDesc:
      'आपने <tmp>{{name}}</tmp> को अपनी टीम में शामिल होने के लिए अस्वीकृत किया है, स्वचालित रूप से ईमेल सूचनाएँ भेजी गई हैं।',
  },
  infoBindPage: {
    title: 'एआई संचालित विज्ञापन परीक्षण',
    desc: 'मल्टी-मॉडल बड़े भाषा मॉडल (HMLLM)* के आधार पर, सृजनात्मकता की प्रभावशीलता की भविष्यवाणी को तेजी से लागू करें और विज्ञापन पर निवेश पर रिटर्न बढ़ाएं',
    joinAdEff: 'AdEff में शामिल हों और एक नई यात्रा शुरू करें',
    advantages: {
      title1: 'अधिक शक्तिशाली',
      desc1: 'विशाल डेटाबेस पर आधारित अद्वितीय एआई मॉडल',
      title2: 'अधिक आर्थिक',
      desc2: 'परंपरागत तरीकों की कीमत का केवल 10%',
      title3: 'अधिक तेज़',
      desc3: 'सबसे तेज़ रिपोर्ट 15 मिनट में',
      title4: 'अधिक पेशेवर',
      desc4: '24/7 सेवा समर्थन और विशेषज्ञ टीम सेवाएं',
    },
    username: 'उपयोगकर्ता नाम',
    company: 'कंपनी',
    placeOfResidence: 'देश/क्षेत्र',
    invitationCode: 'रेफरल कोड',
    createAccountForFree: 'मुफ्त खाता बनाएं',
    refreshStatus: 'स्थिति ताज़ा करें',
    reapply: 'फिर से आवेदन करें',
    bySigningUp: 'पंजीकरण करके, आप सहमत हैं',
    termsOfService: 'सेवा की शर्तें',
    and: 'और',
    privacyPolicy: 'गोपनीयता नीति',
    message: {
      success: 'खाता बनाने का अनुरोध भेजा गया है, कृपया प्रतीक्षा करें!',
      success2: 'खाता सफलतापूर्वक बनाया गया',
      error: 'खाता बनाने में विफल, कृपया बाद में प्रयास करें।',
      accountCreatedDirectly: 'आपका खाता सीधे बनाया गया है!',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        'अनुरोध स्वीकृत हो गया है, पृष्ठ स्वचालित रूप से पुनः निर्देशित किया जाएगा।',
      theRequestHasBeenSendAndPleaseBePatient: 'अनुरोध भेजा गया है, कृपया प्रतीक्षा करें!',
      wrongRouting: 'रूटिंग में त्रुटि, पृष्ठ स्वचालित रूप से पुनः निर्देशित किया जाएगा।',
      yourRequestHasBeenDeclined:
        'आपका अनुरोध अस्वीकृत कर दिया गया है। आप टीम में शामिल होने के लिए फिर से आवेदन कर सकते हैं या बिना आमंत्रण कोड के नया खाता बना सकते हैं।',
      waitingForAdministratorReview: 'व्यवस्थापक की समीक्षा की प्रतीक्षा कर रहे हैं',
      thisFieldIsRequired: 'यह फ़ील्ड आवश्यक है',
      pleaseEnterTheResidence: 'कृपया देश दर्ज करें',
      invitationCodeDoesNotExist: 'अमान्य रेफरल कोड',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        'यदि आप एजेंट रेफरल के माध्यम से इसका उपयोग कर रहे हैं, तो कृपया रेफरल कोड दर्ज करें',
      pleaseEnterTheUsername: 'कृपया उपयोगकर्ता नाम दर्ज करें',
      pleaseEnterTheCompanyName: 'कृपया कंपनी का नाम दर्ज करें',
      needRegisterAgain: 'ऑपरेशन अप्रयोगी, कृपया फिर से रजिस्टर करें',
      alreadyBind: 'आप पहले ही कंपनी बांड कर चुके हैं, कृपया फिर से बांड न करें',
    },
  },
  knowledgeFormPage: {
    name: 'आपका नाम',
    email: 'आपका ईमेल',
    companyName: 'कंपनी का नाम',
    department: 'विभाग',
    role: 'भूमिका',
    country: 'देश',
    province: 'प्रांत',
    pleaseEnter: 'कृपया दर्ज करें',
    pleaseSelect: 'कृपया चुनें',
    pleaseEnterTheName: 'कृपया अपना नाम दर्ज करें',
    pleaseEnterTheEmail: 'कृपया अपना ईमेल दर्ज करें',
    pleaseEnterValidEmail: 'कृपया मान्य ईमेल दर्ज करें',
    pleaseEnterTheCompanyName: 'कृपया अपनी कंपनी का नाम दर्ज करें',
    pleaseSelectTheDepartment: 'कृपया अपना विभाग चुनें',
    pleaseSelectTheRole: 'कृपया अपनी भूमिका चुनें',
    pleaseSelectTheCountry: 'कृपया अपना देश चुनें',
    pleaseSelectTheProvince: 'कृपया अपना प्रांत चुनें',
    textIsRequired: 'यह फ़ील्ड आवश्यक है',
    submit: 'जमा करें',
    download: 'डाउनलोड',
    submitSuccess: 'जमा करना सफल',
    downloadSuccess: 'डाउनलोउनलोड सफल',
    title1: 'कृपया संसाधन प्राप्त करने के लिए अपनी जानकारी भरें',
    title2: 'कृपया डाउनलोड करने के लिए संसाधन चुनें',
  },
  dashboard: {
    pdf: {
      downloadReport: 'रिपोर्ट डाउनलोड करें',
      downloadBtnText: 'PDF डाउनलोड करें',
      content: 'सामग्री',
      theEnd: 'अंत',
      thankYouForWatching: 'देखने के लिए धन्यवाद।',
      pdfProcessing: 'PDF प्रकार में...',
      pdfProcessingDesc:
        'PDF पेज: {{count}}，अपेक्षित {{seconds}} सेकंड，सफल होने के बाद सही है, कृपया प्रतीक्षा करें',
      pdfProcessingDesc2: 'वर्तमान भाषा संस्करण अनुवाद नहीं है, PDF उत्पन्न नहीं किया जा सकता है',
    },
    ppt: {
      downloadBtnText: 'PPT डाउनलोड करें',
      pptProcessingDesc: 'PPT फ़ाइल बन रही है, कृपया प्रतीक्षा करें',
      pptProcessingDesc2:
        'वर्तमान भाषा संस्करण का अनुवाद नहीं किया गया है, PPT उत्पन्न नहीं किया जा सकता है',
      pptProcessingDesc3: 'PPT फ़ाइल डाउनलोड हो रही है, कृपया प्रतीक्षा करें...',
      translateCompleted: 'PPT अनुवाद पूरा हुआ',
      exportSuccess: 'PPT फ़ाइल सफलतापूर्वक निर्यात की गई',
      exportFailed: 'PPT फ़ाइल निर्यात करने में विफल',
    },
    layout: {
      projectMenuText: 'विज्ञापन परीक्षण परियोजनाएँ',
      accountManagementText: 'खाता प्रबंधन',
      myAccountText: 'मेरा खाता',
      subscriptionText: 'सदस्यता',
      logout: 'लॉगआउट',
      dataDetails: 'डेटा विवरण',
      dataAnalysis: 'डेटा विश्लेषण',
      dataOverview: 'डेटा अवलोकन',
      dataComparison: 'डेटा तुलना',
    },
    systemMessage: {
      title: 'सिस्टम संदेश',
      task: 'कार्य',
      system: 'सिस्टम',
      noRelevantContent: 'कोई प्रासंगिक सामग्री नहीं मिली',
      noMore: 'कोई और संदेश नहीं है',
    },
    projectPage: {
      createProject: 'परियोजना बनाएं',
      searchPlaceholder: 'परियोजना/विज्ञापन/ब्रांड का नाम दर्ज करें',
      sortLabel: 'विज्ञापन प्रभाव सूचकांक क्रमबद्ध करें',
      sortPlaceholder: 'कृपया क्रमबद्ध करने का तरीका चुनें',
      sortOption1: 'प्रभाव सूचकांक के आरोही क्रम में',
      sortOption2: 'प्रभाव सूचकांक के अवरोही क्रम में',
      filterSort: 'फ़िल्टर और क्रमबद्ध करें',
      filterBenchmarkTitle: 'बेंचमार्क फ़िल्टर करें',
      sortTitle: 'क्रमबद्ध करें',
      tabAllCreative: 'सभी क्रिएटिव ({{count}})',
      tabGeneralCreative: 'नियमित क्रिएटिव ({{count}})',
      tabSplashCreative: 'स्प्लैश क्रिएटिव ({{count}})',
      generalCreativeLabel: 'नियमित क्रिएटिव',
      splashCreativeLabel: 'स्प्लैश क्रिएटिव',
      normTypePlaceholder: 'कृपया मानक प्रकार चुनें',
      totalDesc: 'विज्ञापन परियोजनाएं (कुल {{total}})',
      noRelevantContent: 'कोई प्रासंगिक सामग्री नहीं मिली',
      loadMore: 'और लोड करें',
      projectCard: { delete: 'हटाएं', reanalyze: 'फिर से विश्लेषण करें', download: 'डाउनलोड' },
      delete: 'हटाएं',
      cancel: 'रद्द करें',
      message: {
        deleteTitle: 'हटाने की चेतावनी',
        delete:
          'एक बार जब आप इस परियोजना को हटा देते हैं, तो सभी संबंधित डेटा अनुपलब्ध हो जाएंगे। क्या आप हटाने के लिए आगे बढ़ना चाहते हैं?',
        delete1:
          'यह परियोजना एक मुफ्त परीक्षण परियोजना है, और इसे हटाने से मुफ्त परीक्षण का अवसर वापस नहीं आएगा',
        delete2:
          'इस परियोजना का विश्लेषण अभी शुरू नहीं हुआ है। हटाने के बाद, आपके परीक्षण क्रेडिट वापस कर दिए जाएंगे',
        deleteSuccess: 'हटाना सफल!',
        analysisCountNotEnough: 'विश्लेषण संख्या अपर्याप्त है, कृपया फिर से आगे बढ़ें।',
        analysisFailed: 'विश्लेषण विफल, कृपया फिर से आगे बढ़ें।',
        waitingQuestion:
          'अधिकतम 3 परियोजनाओं का एक साथ विश्लेषण किया जा सकता है। यह परियोजना प्रतीक्षा सूची में प्रवेश कर गई है और बाद में स्वचालित रूप से विश्लेषण शुरू होगा।',
        landscapeQuickCompleted: 'आपका क्षैतिज क्विक टेस्ट प्रोजेक्ट पूरा हो गया है।',
        portraitQuickCompleted: 'आपका वर्टिकल क्विक टेस्ट प्रोजेक्ट पूरा हो गया है।',
        landscapeSurveyCompleted: 'आपका क्षैतिज डीप इनसाइट प्रोजेक्ट पूरा हो गया है।',
        portraitSurveyCompleted: 'आपका वर्टिकल डीप इनसाइट प्रोजेक्ट पूरा हो गया है।',
      },
    },
    projectCreatePage: {
      createProject: 'परियोजना बनाएं',
      basicInformation: 'बुनियादी जानकारी',
      projectType: 'परियोजना का प्रकार',
      projectName: 'परियोजना का नाम',
      categoryType: 'उद्योग',
      brandName: 'ब्रांड का नाम',
      advertisingInformation: 'विज्ञापन जानकारी',
      adName: 'विज्ञापन का नाम',
      targetMarketNorm: 'लक्षित बाजार मानक',
      norm: 'मानक',
      brandNorm: 'ब्रांड मानक',
      taGender: 'लक्षित दर्शकों का लिंग',
      targetMarket: 'लक्षित बाजार',
      taAge: 'लक्षित दर्शकों की आयु',
      next: 'अगला',
      previous: 'पिछला',
      confirmOrder: 'आदेश की पुष्टि करें',
      estTime: 'अनुमानित समय',
      minutes: 'मिनट',
      consumption: 'इस आदेश का उपभोग',
      testPoint: 'परीक्षणों की संख्या',
      remaining: 'बचे हुए',
      times: 'बार',
      type: 'प्रकार',
      purchase: 'खरीदें',
      outputLanguage: 'आउटपुट भाषा',
      durationCategory: 'क्रिएटिव प्रकार',
      durationCategoryDesc: 'विश्लेषण मेट्रिक्स क्रिएटिव प्रकार के अनुसार बदलते हैं, कृपया अपनी सामग्री के लिए सबसे उपयुक्त विकल्प चुनें।',
      durationCategoryOptions: {
        tenPlus: 'सामान्य क्रिएटिव (10से+)',
        fiveToTen: 'ओपनिंग क्रिएटिव (5-10से)',
      },
      adSelection: {
        adCreativeTest: 'विज्ञापन सृजनात्मकता परीक्षण',
        adCreativeTestDesc:
          'एक विज्ञापन सृजनात्मकता पर लक्षित दर्शकों की प्रतिक्रियाओं का परीक्षण करना, विश्लेषण और सिफारिशें प्रदान करना',
        adCreativeSelection: 'विज्ञापन सृजनात्मकताओं का चयन',
        adCreativeSelectionDesc:
          'कई विज्ञापन सृजनात्मकताओं पर प्रतिक्रियाओं की तुलना करना, समग्र चयन',
        adCreativeEditing: 'विज्ञापन सृजनात्मकताओं का संपादन',
        adCreativeEditingDesc:
          'सर्वश्रेष्ठ विज्ञापन सृजनात्मकता के हिस्सों के लिए एआई का चयन करना, और स्वचालित रूप से विज्ञापन सृजनात्मकता बनाना',
        launchingSoon: 'जल्द ही लॉन्च होगा',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: 'भोजन और पेय श्रेणी',
        packagedFood: 'पैकेज किया हुआ भोजन',
        confectionery: 'कॉन्फेटरी',
        frozenMeals: 'फ्रीज किया हुआ भोजन',
        fastFood: 'त्वरित भोजन',
        beverage: 'पेय',
        alcohol: 'शराब',
        dairy: 'दूध',
        grainAndSeasoning: 'दाना और सौहार्द',
        beverageMixes: 'पेय मिश्रण',
        freshProduce: 'ताजा फल और सब्जियां',
        otherFoodAndBeverage: 'अन्य भोजन और पेय',
        /**----------------------- */
        consumerElectronicsCategory: 'उपभोक्ता इलेक्ट्रॉनिक्स श्रेणी',
        mobilePhone: 'मोबाइल फ़ोन',
        computer: 'कंप्यूटर',
        smartDevice: 'स्मार्ट डिवाइस',
        phoneAccessories: 'फ़ोन एक्ससेसरीज',
        computerAccessories: 'कंप्यूटर एक्ससेसरीज',
        software: 'सॉफ़्टवेयर',
        camera: 'कैमरा',
        officeSupplies: 'कार्यालय सामग्री',
        otherConsumerElectronics: 'अन्य उपभोक्ता इलेक्ट्रॉनिक्स',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: 'औषधि और स्वास्थ्य के लिए श्रेणी',
        otcMedicine: 'OTC औषधि',
        prescriptionDrugs: 'औषधि और स्वास्थ्य के लिए श्रेणी',
        healthSupplements: 'स्वास्थ्य सहायक',
        pharmaceuticalCompanies: 'औषधि कंपनियां',
        medicalDevices: 'चिकित्सा उपकरण',
        medicalServices: 'चिकित्सा सेवाएं',
        pharmacy: 'फार्मासी',
        otherPharmaceuticalsAndHealthCare: 'अन्य औषधि और स्वास्थ्य के लिए',
        /**----------------------- */
        beautyAndPersonalCareCategory: 'सुंदरता और व्यक्तिगत देखभाल श्रेणी',
        hairCare: 'बाल देखभाल',
        womenSkincare: 'देवियों त्वचा देखभाल',
        homeCleaning: 'घर सफाई',
        bodyCare: 'शरीर देखभाल',
        feminineCare: 'महिला देखभाल',
        oralCare: 'होल देखभाल',
        menSkincare: 'पुरुष देखभाल',
        makeup: 'मुक्ति',
        fragrances: 'सुगंध',
        beautyServices: 'सुंदरता सेवाएं',
        otherBeautyAndPersonalCare: 'अन्य सुंदरता और व्यक्तिगत देखभाल',
        /**----------------------- */
        maternalAndInfantProductsCategory: 'मदर और बच्चे के उत्पाद श्रेणी',
        babyFood: 'बच्चे का भोजन',
        babyCareEssentials: 'बच्चे की देखभाल की आवश्यकताएं',
        babyToys: 'बच्चे के खिलौने',
        otherMaternalAndInfantProducts: 'अन्य मदर और बच्चे के उत्पाद',
        /**----------------------- */
        networkAndCommunicationCategory: 'नेटवर्क और संचार श्रेणी',
        mobileCarriers: 'मोबाइल कार्यकर्ता',
        internetProviders: 'इंटरनेट प्रदाता',
        telecomEquipment: 'संचार उपकरण',
        otherNetworkAndCommunication: 'अन्य नेटवर्क और संचार',
        /**----------------------- */
        travelAndAccommodationCategory: 'यात्रा और आवास श्रेणी',
        localTourism: 'स्थानीय यात्रा',
        bookingPlatform: 'बुकिंग प्लेटफ़ॉर्म',
        hotels: 'होटल',
        airlines: 'हवाई जहाज',
        airport: 'हवाई अड्डा',
        otherTravelAndAccommodation: 'अन्य यात्रा और आवास',
        /**----------------------- */
        vehiclesCategory: 'यातायात श्रेणी',
        motorVehicleProductsAndServices: 'मोटर वाहन उत्पाद और सेवाएं',
        carBrands: 'कार ब्रांड',
        dealerships: 'डीलरशिप',
        carFinance: 'कार फ़ाइनेंस',
        evCar: 'इलेक्ट्रिक कार',
        motorcycle: 'मोटरसाइकिल',
        onlineUsedCarMarketplace: 'ऑनलाइन उपयोग किया गया कार बाजार',
        carRentalPlatform: 'कार किराया प्लेटफ़ॉर्म',
        travelNavigation: 'यात्रा नेविगेशन',
        bicycle: 'साइकिल',
        otherVehicles: 'अन्य यातायात',
        /**----------------------- */
        householdAppliancesCategory: 'घरेलू उपकरण श्रेणी',
        majorAppliances: 'मुख्य उपकरण',
        healthAndPersonalCareAppliances: 'स्वास्थ्य और व्यक्तिगत देखभाल उपकरण',
        majorKitchenAndBathAppliances: 'मुख्य खाद्य उपकरण',
        smallKitchenAppliances: 'छोटे खाद्य उपकरण',
        environmentalAppliances: 'पर्यावरण उपकरण',
        cleaningAppliances: 'सफाई उपकरण',
        otherHouseholdAppliances: 'अन्य घरेलू उपकरण',
        /**----------------------- */
        retailAndServiceCategory: 'रिटेल और सेवा श्रेणी',
        onlineRetailEcommerce: 'ऑनलाइन रिटेल/एलेक्ट्रॉनिक व्यापार',
        departmentStores: 'डिपार्टमेंट स्टोर',
        lifeServices: 'जीवन सेवाएं',
        retailServicesAndDelivery: 'रिटेल सेवाएं/डिलीवरी',
        supermarkets: 'सुपरमार्केट',
        otherRetailAndService: 'अन्य रिटेल और सेवा',
        /**----------------------- */
        apparelCategory: 'वस्त्र और उपभोग श्रेणी',
        footwear: 'फूटवर्क',
        clothing: 'वस्त्र',
        watchesWatchRetail: 'घड़ी/घड़ी रिटेल',
        jewelry: 'जेवेलरी',
        bags: 'बैग',
        eyewearOpticalStores: 'आँख देखभाल स्टोर',
        otherClothingAndAccessories: 'अन्य वस्त्र और उपभोग',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: 'घरेलू सुधार और उपभोग श्रेणी',
        homeFurnishing: 'घरेलू उपभोग',
        homeImprovement: 'घरेलू सुधार',
        otherHomeImprovementAndFurnishings: 'अन्य घरेलू सुधार और उपभोग',
        /**----------------------- */
        financialAndInsuranceCategory: 'वित्त और बीमा श्रेणी',
        bank: 'बैंक',
        fintech: 'फ़िनटेक',
        investmentAndFinancialServices: 'निवेश और वित्तीय सेवाएं',
        insurance: 'बीमा',
        otherFinancialAndInsurance: 'अन्य वित्त और बीमा',
        /**----------------------- */
        entertainmentAndLeisureCategory: 'मनोरंजन और आराम श्रेणी',
        socialApp: 'सोशल ऐप',
        toysAndDolls: 'खिलौने और डॉल्स',
        concerts: 'कंकर्ट',
        events: 'ईवेंट',
        movies: 'चलचित्र',
        themeParks: 'थीम पार्क',
        gambling: 'जुआंग',
        onlineGaming: 'ऑनलाइन गेमिंग',
        tvChannels: 'टीवी चैनल',
        otherEntertainmentAndLeisure: 'अन्य मनोरंजन और आराम',
        /**----------------------- */
        industrialAndAgriculturalCategory: 'उद्योग और कृषि श्रेणी',
        industrialSupplies: 'उद्योग सामग्री',
        agriculturalSupplies: 'कृषि सामग्री',
        otherIndustrialAndAgricultural: 'अन्य उद्योग और कृषि',
        /**----------------------- */
        petLifeCategory: 'पालतू जीवन श्रेणी',
        petFood: 'पालतू भोजन',
        petSupplies: 'पालतू सामग्री',
        otherPetLife: 'अन्य पालतू जीवन',
        /**----------------------- */
        educationAndLearningCategory: 'शिक्षा और अध्ययन श्रेणी',
        onlineLearning: 'ऑनलाइन अध्ययन',
        schools: 'स्कूल',
        skillCourses: 'कौशल कोर्स',
        tutoring: 'ट्यूटर',
        universities: 'विश्वविद्यालय',
        otherEducationAndLearning: 'अन्य शिक्षा और अध्ययन',
        /**----------------------- */
        communityAndPublicServiceCategory: 'समुदाय और सार्वजनिक सेवा श्रेणी',
        charityCampaigns: 'दान कार्यक्रम',
        ngoAds: 'एनजीओ विज्ञापन',
        otherCommunityAndPublicService: 'अन्य समुदाय और सार्वजनिक सेवा',
        /**----------------------- */
        otherCategory: 'अन्य श्रेणी',
        governmentAdvertising: 'सरकारी विज्ञापन',
        realEstateAdvertising: 'विश्वसनीय विज्ञापन',
        otherAdvertising: 'अन्य विज्ञापन',
      },
      genderSelect: {
        male: 'पुरुष',
        female: 'महिला',
        all: 'सभी',
      },
      targetMarketSelect: {
        China: 'चीन',
        HongKongChina: 'हांगकांग, चीन',
        MacauChina: 'मकाऊ, चीन',
        TaiwanChina: 'ताइवान, चीन',
        Japan: 'जापान',
        Korea: 'कोरिया',
        Mongolia: 'मंगोलिया',
        Singapore: 'सिंगापुर',
        Thailand: 'थाईलैंड',
        Vietnam: 'वियतनाम',
        Malaysia: 'मलेशिया',
        Philippines: 'फिलीपींस',
        Indonesia: 'इंडोनेशिया',
        Cambodia: 'कंबोडिया',
        Laos: 'लाओस',
        India: 'भारत',
        SaudiArabia: 'सऊदी अरब',
        Turkey: 'तुर्की',
        Israel: 'इज़राइल',
        UnitedArabEmirates: 'संयुक्त अरब अमीरात',
        Qatar: 'कतर',
        Kuwait: 'कुवैत',
        UnitedKingdom: 'यूनाइटेड किंगडम',
        France: 'फ्रांस',
        Germany: 'जर्मनी',
        Netherlands: 'नीदरलैंड्स',
        Belgium: 'बेल्जियम',
        Austria: 'ऑस्ट्रिया',
        Italy: 'इटली',
        Spain: 'स्पेन',
        Portugal: 'पुर्तगाल',
        Greece: 'यूनान',
        Sweden: 'स्वीडन',
        Norway: 'नॉर्वे',
        Finland: 'फिनलैंड',
        Denmark: 'डेनमार्क',
        Estonia: 'एस्टोनिया',
        Latvia: 'लातविया',
        Russia: 'रूस',
        Poland: 'पोलैंड',
        CzechRepublic: 'चेक गणराज्य',
        Hungary: 'हंगरी',
        Romania: 'रोमानिया',
        Bulgaria: 'बुल्गारिया',
        Slovakia: 'स्लोवाकिया',
        Slovenia: 'स्लोवेनिया',
        Ukraine: 'यूक्रेन',
        UnitedStates: 'संयुक्त राज्य अमेरिका',
        Canada: 'कनाडा',
        Mexico: 'मेक्सिको',
        Brazil: 'ब्राज़ील',
        LatinAmerica: 'लैटिन अमेरिका',
        Australia: 'ऑस्ट्रेलिया',
        NewZealand: 'न्यूज़ीलैंड',
        Other: 'अन्य',
      },
      languageSelect: {
        english: 'इंग्लिश',
        chinese: 'चीनी',
        japanese: 'जापानी',
        korean: 'कोरियाई',
        french: 'फ्रेंच',
        traditionalChinese: 'चीनी पारंपरिक',
      },
      placeholder: {
        projectName: 'परियोजना का नाम दर्ज करें',
        category: 'श्रेणी चुनें',
        brandName: 'ब्रांड का नाम दर्ज करें',
        adName: 'विज्ञापन का नाम दर्ज करें',
        norm: 'कृपया मानक मान चुनें',
        taGender: 'लिंग चुनें',
        targetMarket: 'लक्षित बाजार चुनें',
        taAge: 'आयु चुनें',
        lowerLimit: 'न्यूनतम सीमा',
        upperLimit: 'अधिकतम सीमा',
        outputLanguage: 'कृपया आउटपुट भाषा चुनें',
      },
      step: {
        step1: 'परियोजना की जानकारी दर्ज करें',
        step2: 'आदेश की जानकारी की पुष्टि करें',
      },
      message: {
        success: 'सफलता से बनाया गया',
        videoDurationOver60s: 'वीडियो की अवधि {{max}} सेकंड से अधिक है',
        videoDurationLessThan10s: 'वीडियो की अवधि {{min}} सेकंड से कम है',
        videoDurationNeedOver10s: 'वीडियो की अवधि 10 सेकंड से अधिक होनी चाहिए',
        videoDurationNeedWithin5To10s: 'वीडियो की अवधि 5 से 10 सेकंड के बीच होनी चाहिए',
        videoDurationNotMatchDurationCategory: 'वर्तमान वीडियो अवधि इस प्रकार के प्रोजेक्ट परीक्षण के अनुरूप नहीं है। कृपया वीडियो दोबारा अपलोड करें और फिर प्रयास करें।',
        videoUploadingCannotSwitchDurationCategory: 'वीडियो अपलोड होते समय क्रिएटिव प्रकार नहीं बदला जा सकता। कृपया अपलोड पूरा होने तक प्रतीक्षा करें।',
        videoFormatOrDurationError: 'वीडियो फ़ॉर्मेट या अवधि पढ़ी नहीं जा सकी। कृपया वीडियो फ़ाइल जांचें और फिर से प्रयास करें।',
        videoSizeOver200M: 'वीडियो का आकार 256 एमबी से अधिक है',
        videoLandscape: 'वीडियो को हॉरिजॉंटल प्रारूप में होना चाहिए',
        videoPortrait: 'वीडियो पोर्ट्रेट फ़ॉर्मेट में होना चाहिए',
        clickToUploadTestVideo: 'परीक्षण वीडियो अपलोड करने के लिए क्लिक करें',
        uploadFailed: 'अपलोड विफल, कृपया पुनः प्रयास करें',
        uploadDesc1: 'MP4, MOV में वीडियो फ़ाइलों का समर्थन करता है,',
        uploadDescPortrait: 'MP4, MOV में पोर्ट्रेट वीडियो फ़ाइलों का समर्थन करता है',
        uploadDesc2: 'अन्य प्रारूप, 256MB तक की फ़ाइल आकार सीमा के साथ',
        formNotCompleted: 'कृपया सभी जानकारी भरें',
        uploadAdVideo: 'कृपया विज्ञापन वीडियो अपलोड करें',
        inputInvalid: 'अमान्य इनपुट',
        insufficientTestPoints:
          'आपके पास पर्याप्त परीक्षण अंक नहीं हैं। कृपया पुनः प्रयास करने के लिए पुनः लोड करें।',
        reviewProjectInfo:
          'कृपया अपने प्रोजेक्ट की जानकारी को ध्यान से जांचें। एक बार आदेश की पुष्टि होने के बाद, परिवर्तन संभव नहीं होंगे।',
        waitingDesc:
          'अधिकतम 3 परियोजनाओं का एक साथ विश्लेषण किया जा सकता है। यह परियोजना प्रतीक्षा सूची में प्रवेश कर गई है और बाद में स्वचालित रूप से विश्लेषण शुरू होगा।',
        ageRangeInvalid: 'आयु सीमा केवल 20-55 के लिए समर्थित है',
        normDesc: 'अनिश्चित अधिकार लाभ, कंपनी द्वारा अपना मानक मान बनाया गया',
      },
    },
    projectDetailPage: {
      testResults: 'परीक्षण परिणाम',
      share: 'साझा करें',
      shareFailed: 'साझा करना विफल रहा',
      shareModal: {
        title: 'साझा करें',
        desc: 'नीचे दिया गया टेक्स्ट कॉपी करें और सोशल मीडिया पर साझा करें।',
        saveImage: 'छवि सहेजें',
        copyText: 'टेक्स्ट कॉपी करें',
        copySuccess: 'कॉपी हो गया',
        copyFailed: 'कॉपी विफल',
        textTemplate:
          'वाह! मेरी AI क्रिएटिव ने AdEff पर {{score}}% समान क्रिएटिव्स को पीछे छोड़ दिया! असली ताकत डेटा में है! AdEff AI Creative Testing अभी मुफ्त है। अपना स्कोर {{hostname}} पर देखें। 5 मुफ्त टेस्ट पाएं, और बेहतरीन रेटिंग्स की शुभकामनाएँ!',
      },
      sharePoster: {
        createdByYou: 'आपकी बनाई हुई',
        scoreTemplate: '<score>{{score}}</score> AIGC रचनात्मक कार्यों से बेहतर',
        statsAt: 'आँकड़े समय ',
        certification: 'क्रिएटिव प्रमाणन',
        footerText: 'आप निरंतर रचना करें और और भी उत्कृष्ट कार्य लाएँ!',
      },
      basicInformation: 'बुनियादी जानकारी',
      waiting: 'इंगित रहा है',
      ongoing: 'चल रहा है',
      failed: 'विफल',
      tryAgain: 'फिर से प्रयास करें',
      videoAnalysisFailed: 'वीडियो विश्लेषण विफल',
      message: { projectNotFound: 'परियोजना नहीं मिली' },
      primaryAnalysis: 'प्राथमिक विश्लेषण',
      detailAnalysis: 'पल विश्लेषण',
      heatmapAnalysis: 'हीटमैप',
      analysisStepDesc: 'एआई ने सभी विश्लेषण कार्य पूरे कर लिए हैं, विस्तृत विश्लेषण नीचे है',
      analysisWaitingDesc:
        'अधिकतम 3 परियोजनाओं का एक साथ विश्लेषण किया जा सकता है। यह परियोजना प्रतीक्षा सूची में प्रवेश कर गई है और बाद में स्वचालित रूप से विश्लेषण शुरू होगा।',
      aiTip: 'विवरण की जानकारी एआई द्वारा उत्पन्न की गई है और केवल संदर्भ के लिए है',
      subAnalysisDescription: {
        adVideoScore: 'विज्ञापन प्रभावशीलता सूचकांक',
        adVideoScoreDesc:
          'विज्ञापन प्रभावशीलता सूचकांक विज्ञापन के प्रभाव को मापने के लिए एक सामान्यीकृत सूचकांक है।',
        norm: 'मानक',
        normDesc:
          'उद्योग या ऐतिहासिक डेटा के लिए मानक मान, विज्ञापन प्रदर्शन की क्षैतिज तुलना के लिए उपयोग किया जाता है।',
        attentionIndex: 'ध्यान सूचकांक',
        attentionIndexDesc:
          'दर्शकों का दृश्य ध्यान केंद्रित करने की डिग्री, विज्ञापन छवि में कथानक और तत्वों को देखने के लिए आकर्षित करने की क्षमता को दर्शाता है।',
        emotionIndex: 'भावनाओं का सूचकांक',
        emotionIndexDesc:
          'दर्शकों की सकारात्मक भावनाओं को उत्तेजित करने की डिग्री, विज्ञापन द्वारा उत्पन्न तात्कालिक भावनात्मक उतार-चढ़ाव को दर्शाता है।',
        cognitionIndex: 'ज्ञान सूचकांक',
        cognitionIndexDesc:
          'दर्शकों की ज्ञान प्रसंस्करण की डिग्री को दर्शाता है, अर्थात् विज्ञापन सामग्री पर विचार करने की डिग्री।',
        theGolden3Seconds: 'सोने के 3 सेकंड',
        theGolden3SecondsDesc:
          'विज्ञापन के पहले 3 सेकंड सफल होने या न होने का निर्णय लेने के लिए महत्वपूर्ण क्षण हैं।',
        informationTransmission: 'जानकारी क्षण',
        informationTransmissionDesc:
          'लक्षित दर्शकों के ध्यान को पकड़ने और रुचि को उत्तेजित करने की क्षमता को मापता है।',
        brandRelevance: 'ब्रांड क्षण',
        brandRelevanceDesc:
          'ब्रांड क्षण के लिए दर्शकों के ध्यान को पकड़ने और रुचि को उत्तेजित करने की क्षमता को मापता है।',
        interestStimulation: 'रुचि क्षण',
        interestStimulationDesc:
          'दर्शकों की भावनात्मक गूंज और सक्रिय ज्ञान के लिए महत्वपूर्ण सामग्री क्षण।',
        theEnding3Seconds: 'अंतिम 3 सेकंड',
        theEnding3SecondsDesc:
          'शिखर-समापन नियम के आधार पर, विज्ञापन के अंतिम 3 सेकंड दर्शकों के ध्यान को मजबूत करने और जानकारी के संचरण को बढ़ाने के लिए महत्वपूर्ण क्षण हैं।',
      },
      infoDrawer: {
        basicInformation: 'बुनियादी जानकारी',
        advertisingInformation: 'विज्ञापन जानकारी',
        projectName: 'परियोजना का नाम',
        brandName: 'ब्रांड का नाम',
        category: 'उद्योग',
        norm: 'लक्षित बाजार मानक',
        normLabel: 'मानक',
        brandNorm: 'ब्रांड मानक',
        adName: 'विज्ञापन का नाम',
        taGender: 'लक्षित दर्शकों का लिंग',
        targetMarket: 'लक्षित बाजार',
        taAge: 'लक्षित दर्शकों की आयु',
        ageRange: '{{start}} से {{end}} वर्ष',
        modify: 'अद्यतन',
        cancel: 'रद्द',
        confirm: 'पुष्टि',
      },
      videoView: {
        eyeMovementRatio: 'ध्यान सूचकांक',
        cognitiveEngagement: 'ज्ञान सूचकांक',
        emotionRecognition: 'भावनाओं का सूचकांक',
        subjectiveResponseCurve: 'विषयगत प्रतिक्रिया वक्र',
        realtimeData: 'वास्तविक डेटा',
        panoramicData: 'पैनोरामिक डेटा',
        indexAnalysis: 'सूचकांक विश्लेषण',
        advantage: 'लाभ',
        disadvantage: 'हानियाँ',
        suggestions: 'सिफारिशें',
        adVideoScore: 'विज्ञापन प्रभावशीलता सूचकांक',
        norm: 'मानक',
        analysisStepTitle1: 'सामग्री का डिकोडिंग',
        analysisStepTitle2: 'प्रतिक्रिया की भविष्यवाणी',
        analysisStepTitle3: 'डेटा का एकीकरण',
        analysisStepTitle4: 'निष्कर्ष और सिफारिशें',
        analysisStepDesc1:
          'विज्ञापन सामग्री के मल्टी-मॉडल डिकोडिंग की प्रक्रिया शुरू करें, दृश्य, ऑडियो, पाठ, और संरचना का डिकोडिंग...',
        analysisStepDesc2:
          'दर्शकों की विषयगत प्रतिक्रिया की भविष्यवाणी शुरू करें, विज्ञापन की सामग्री के आधार पर, दर्शकों की आंखों की गति और ईईजी डेटा की भविष्यवाणी करें...',
        analysisStepDesc3:
          'विज्ञापन की वस्तुनिष्ठ सामग्री और दर्शकों की विषयगत प्रतिक्रिया डेटा का एकीकृत शुरू करें...',
        analysisStepDesc4:
          'निष्कर्ष और कार्यवाही की सिफारिशें उत्पन्न करने के लिए अनुमान मॉडल के आधार पर शुरू करें...',
        keyResult: 'मुख्य परिणाम',
        videoChart: {
          videoFailed: 'वीडियो प्लेबैक विफल हुआ',
          videoFailedAction:
            'कृपया रीफ्रेश करें और पुनः प्रयास करें। यदि समस्या बहुत सारे रीफ्रेश के बाद भी है, तो कृपया हमसे संपर्क करें और सहायता प्राप्त करें।',
        },
      },
      storyboardView: {
        summary: 'सारांश',
        advantages: 'लाभ',
        disadvantages: 'हानियाँ',
        suggestions: 'सिफारिशें',
        keyResult: 'मुख्य परिणाम',
        norm: 'मानक',
        theGolden3Seconds: 'सोने के 3 सेकंड',
        informationTransmission: 'जानकारी क्षण',
        brandRelevance: 'ब्रांड क्षण',
        interestStimulation: 'रुचि क्षण',
        theEnding3Seconds: 'अंतिम 3 सेकंड',
      },
      heatmapView: {},
    },
    accountPage: {
      email: 'ईमेल',
      username: 'उपयोगकर्ता नाम',
      password: 'पासवर्ड',
      setPasswordToEnableEmailLogin: 'ईमेल लॉगिन सक्षम करने के लिए पासवर्ड सेट करें',
      uid: 'UID',
      contactAndReceiveNotifications: 'संपर्क करें और सूचनाएँ प्राप्त करें',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        'इस ईमेल पर AdEff के नवीनतम अपडेट के बारे में ईमेल प्राप्त करें।',
      myWorkspace: 'मेरा कार्यक्षेत्र',
      newRequest: 'नया अनुरोध',
      invitationCode: 'रेफरल कोड',
      userName: 'उपयोगकर्ता नाम',
      invitationCodeDesc:
        'प्रत्येक टीम के पास एक अद्वितीय आमंत्रण कोड होता है, जिसका उपयोग नए उपयोगकर्ता पंजीकरण के दौरान टीम में शामिल होने के लिए करते हैं',
      table: {
        userName: 'उपयोगकर्ता नाम',
        email: 'ईमेल',
        operation: 'ऑपरेशन',
        admin: 'व्यवस्थापक',
        remove: 'हटाएं',
        deny: 'अस्वीकृत करें',
        approve: 'स्वीकृत करें',
      },
      message: {
        yourTeamIsFull:
          'आपकी टीम पूरी है। आप हमसे अधिक सदस्यों के लिए संपर्क कर सकते हैं या अन्य सदस्यों को हटा सकते हैं।',
        invitationLinkSent: 'इस ईमेल पते पर आमंत्रण लिंक भेजा गया है!',
        removeReminder: 'हटाने की याद दिलाना',
        remove: 'हटाएं',
        removeMember:
          'एक बार सदस्य को हटाने के बाद, उसने जो सामग्री बनाई है वह बनी रहेगी। क्या आप सदस्य को हटाने के लिए आगे बढ़ना चाहते हैं?',
        removeMemberSuccess: 'सदस्य को सफलतापूर्वक हटा दिया गया!',
        ok: 'ठीक है',
        contactUs: 'संपर्क करें',
        applicationProcessedSuccessfully: 'अनुरोध सफलतापूर्वक संसाधित किया गया!',
        notificationSettingsTurnedOn: 'सूचना सेटिंग्स चालू हैं',
        notificationSettingsTurnedOff: 'सूचना सेटिंग्स बंद हैं',
        setPassword: 'पासवर्ड सेट करें',
        passwordConfirm: 'पुष्टि करें',
        passwordCancel: 'रद्द करें',
        oldPassword: 'पुराना पासवर्ड',
        newPassword: 'नया पासवर्ड',
        pleaseEnterTheOldPassword: 'कृपया पुराना पासवर्ड दर्ज करें',
        pleaseEnterTheNewPassword: 'कृपया नया पासवर्ड दर्ज करें',
        incorrectEntryOfOriginalPassword: 'मूल पासवर्ड में त्रुटि',
        passwordUpdatedSuccessfully: 'पासवर्ड सफलतापूर्वक अपडेट किया गया',
        changeUsername: 'उपयोगकर्ता नाम बदलें',
        confirm: 'पुष्टि करें',
        cancel: 'रद्द करें',
        username: 'उपयोगकर्ता नाम',
        pleaseEnterTheNewUsername: 'कृपया नया उपयोगकर्ता नाम दर्ज करें',
        userNameUpdatedSuccessfully: 'उपयोगकर्ता नाम सफलतापूर्वक अपडेट किया गया',
        addMemberToWorkspace: 'कार्यक्षेत्र में नए सदस्य को जोड़ें',
        notAdminOperate: 'व्यवस्थापक नहीं, ऑपरेशन नहीं कर सकता',
        emailAddress: 'ईमेल पता',
        send: 'भेजें',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          'हम इस पते पर पुष्टि के लिए एक आमंत्रण ईमेल भेजेंगे।',
        workspaceMemberShip: 'कार्यक्षेत्र सदस्यता',
        forMoreMembership: 'अधिक सदस्यता',
        reachedTheCeiling: 'सीमा तक पहुँच गई।',
        incorrectMailboxFormat: 'ईमेल प्रारूप गलत है',
        member: 'सदस्य',
        changeCorpNameTitle: 'कंपनी का नाम बदलें',
        changeCorpNameLabel: 'कंपनी का नाम',
        pleaseEnterTheCorpName: 'कृपया कंपनी का नाम दर्ज करें',
        changeCorpNameSuccess: 'कंपनी का नाम सफलतापूर्वक बदल दिया गया',
        changeCorpNameFailed: 'कंपनी का नाम बदलना असफल हुआ',
        noPermission: 'आपको कंपनी का नाम बदलने की अनुमति नहीं है',
      },
    },
    subscriptionPage: {
      currentPlan: 'वर्तमान योजना',
      getInvoice: 'अपनी चालान प्राप्त करें',
      remainingTimes: 'बचे हुए बार',
      purchaseMore: 'अधिक खरीदें',
      contactUs: 'संपर्क करें',
      teamPlan: 'विशेषज्ञ टीम सेवाएँ',
      unlimited: 'अनंत',
      dueDate: 'समाप्ति तिथि',
      table: {
        usageRecords: 'उपयोग रिकॉर्ड',
        date: 'तारीख',
        projectName: 'परियोजना का नाम',
        projectType: 'परियोजना का प्रकार',
        usageCount: 'बार',
        userName: 'उपयोगकर्ता नाम',
        noRelevantContent: 'कोई प्रासंगिक सामग्री नहीं मिली',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: 'नियमित क्रिएटिव प्रोजेक्ट',
      regularCreative: 'नियमित क्रिएटिव',
      splashCreativeProject: 'स्प्लैश क्रिएटिव प्रोजेक्ट',
      splashCreative: 'स्प्लैश क्रिएटिव',
      projects: 'प्रोजेक्ट',
      localNorm: 'स्थानीय बेंचमार्क',
      projectPassRate: 'प्रोजेक्ट पास दर',
      passRate: 'पास दर',
    },
    dataDetailPage: {
      baseData: 'मूल डेटा',
      totalProjects: 'कुल परियोजनाएँ',
      totalProjectsDesc:
        'सभी विज्ञापन प्रभावशीलता सूचकांक का एकीकरण करने वाली परियोजनाओं की कुल संख्या।',
      // averageEffectivenessIndex: 'औसत प्रभावशीलता सूचकांक',
      // averageEffectivenessIndexDesc: 'सभी विज्ञापन प्रभावशीलता सूचकांकों का औसत।',
      localNormProjects: 'लोकल मानक परियोजनाएँ',
      brandNormProjects: 'ब्रांड मानक परियोजनाएँ',
      normProject: 'लक्षित बाजार मानक परियोजना',
      brandNormProject: 'ब्रांड मानक परियोजना',
      localNorm: 'लोकल मानक',
      localNormDesc:
        'आपके देश को लक्षित करने वाले प्रभावी विज्ञापन परियोजनाओं के विज्ञापन प्रभावशीलता सूचकांक का औसत।',
      norm: 'मानक',
      brandNorm: 'ब्रांड मानक',
      brandNormDesc:
        'आपके अपने ब्रांड मानक मान को लक्षित करने वाले प्रभावी विज्ञापन परियोजनाओं के विज्ञापन प्रभावशीलता सूचकांक का औसत।',
      localProjectPassRate: 'लोकल परियोजना पास दर',
      projectPassRate: 'परियोजना पास दर',
      brandProjectPassRate: 'ब्रांड परियोजना पास दर',
      projectPassRateDesc: 'सभी परियोजनाओं में विज्ञापन प्रभावशीलता सूचकांकों का औसत।',
      advertisingEffectivenessIndexDistribution: 'विज्ञापन प्रभावशीलता सूचकांक वितरण',
      advertisingEffectivenessIndexDistributionDesc:
        'विज्ञापन प्रभावशीलता सूचकांकों के वितरण का प्रतिनिधित्व।',
      item: 'आइटम',
    },
    dataComparisonPage: {
      createCompare: 'नई तुलना',
      createCompareDesc: 'तुलना के लिए कई प्रोजेक्ट चुनें, अधिकतम 10 प्रोजेक्ट।',
      startCompare: 'तुलना शुरू करें',
      compareReport: 'तुलना रिपोर्ट',
      searchPlaceholder: 'तुलना रिपोर्ट का नाम खोजें',
      emptyText: 'अभी कोई तुलना रिपोर्ट नहीं है। पहले तुलना के लिए प्रोजेक्ट चुनें।',
      searchEmptyText: 'कोई तुलना रिपोर्ट नहीं मिली।',
      deleteTitle: 'तुलना रिपोर्ट हटाएं',
      deleteConfirm: 'क्या आप वाकई इस तुलना रिपोर्ट को हटाना चाहते हैं? यह कार्रवाई वापस नहीं ली जा सकती।',
      projectCount: '{{count}} प्रोजेक्ट',
    },
    dataComparisonStartPage: {
      back: 'वापस',
      basicInfo: 'बुनियादी जानकारी',
      reportName: 'रिपोर्ट का नाम:',
      reportNamePlaceholder: 'तुलना रिपोर्ट का नाम दर्ज करें',
      norm: 'बेंचमार्क:',
      normPlaceholder: 'बेंचमार्क चुनें',
      normTip: 'प्रोजेक्ट तुलना के लिए उपयोग किया जाने वाला बेंचमार्क चुनें',
      selectProject: 'प्रोजेक्ट चुनें',
      searchPlaceholder: 'प्रोजेक्ट/विज्ञापन/ब्रांड नाम से खोजें',
      selectedCountPrefix: ' चुने गए ',
      selectedCountSuffix: ' प्रोजेक्ट, अधिकतम {{max}} प्रोजेक्ट',
      startCompare: 'तुलना शुरू करें',
      save: 'सहेजें',
      cancel: 'रद्द करें',
      maxSelectedWarning: 'आप अधिकतम 10 प्रोजेक्ट चुन सकते हैं',
      reportNameRequired: 'तुलना रिपोर्ट का नाम दर्ज करें',
      normRequired: 'बेंचमार्क चुनें',
      projectRequired: 'प्रोजेक्ट चुनें',
    },
    dataComparisonInfoPage: {
      defaultReportName: 'तुलना रिपोर्ट का नाम',
      reportNotFound: 'रिपोर्ट नहीं मिली',
      back: 'वापस',
      modify: 'संपादित करें',
      deletedProjectTip: 'निम्न प्रोजेक्ट: {{names}} हटा दिए गए हैं। पुष्टि करने के बाद तुलना रिपोर्ट अपडेट होगी और हटाए गए प्रोजेक्ट निकाल दिए जाएंगे।',
      confirmDeletedProjects: 'पुष्टि करें',
      metricScore: 'संकेतक स्कोर',
      tabDimension: 'पांच आयाम',
      tabMoment: 'मुख्य क्षण',
      tabAttitude: 'उपभोक्ता दृष्टिकोण',
      adeffScore: 'AdEff स्कोर',
      brandName: 'ब्रांड नाम',
      projectName: 'प्रोजेक्ट नाम',
      industry: 'उद्योग',
      targetMarket: 'लक्षित बाजार',
      gender: 'TA लिंग',
      age: 'TA आयु',
      adProject: 'विज्ञापन प्रोजेक्ट',
      normLabel: 'बेंचमार्क',
      mixedCreativeBenchmarkTip: 'सामान्य क्रिएटिव और स्प्लैश क्रिएटिव की एक साथ तुलना करते समय कोई बेंचमार्क उपलब्ध नहीं होता।',
      emptyProject: 'तुलना डेटा देखने के लिए प्रोजेक्ट चुनें',
      viewProjectDetail: 'प्रोजेक्ट विवरण देखें',
      listSeparator: ', ',
      metricLabels: {
        attention: 'ध्यान शक्ति',
        infectivity: 'भावनात्मक शक्ति',
        delivery: 'संदेश शक्ति',
        brand: 'ब्रांड शक्ति',
        persuasion: 'प्रेरक शक्ति',
        gazeRecognition: 'नज़र पहचान',
        emotionRecognition: 'भावना पहचान',
        engagementRecognition: 'सहभागिता पहचान',
        goldenSeconds: 'सोने के 3 सेकंड',
        brandMoment: 'ब्रांड क्षण',
        productMoment: 'रुचि क्षण',
        messageMoment: 'जानकारी क्षण',
        endingSeconds: 'अंतिम 3 सेकंड',
        likeability: 'पसंद',
        newInformation: 'नई जानकारी',
        messageRelevance: 'संदेश प्रासंगिकता',
        comprehension: 'समझ',
        credibility: 'विश्वसनीयता',
        brandLinkage: 'ब्रांड संबंध',
        uniqueness: 'विशिष्टता',
        learnMoreIntent: 'और जानने की इच्छा',
        purchaseIntent: 'खरीद इरादा',
        recommendIntent: 'साझा करने योग्यता',
        brandLikeabilityLift: 'ब्रांड पसंद वृद्धि',
        purchaseIntentionLift: 'खरीद इरादा वृद्धि',
        attentionIndex: 'ध्यान सूचकांक',
        emotionIndex: 'भावनाओं का सूचकांक',
        cognitionIndex: 'ज्ञान सूचकांक',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: 'आपका TVC क्रिएटिव मूल्यांकन प्रोजेक्ट पूरा हो गया है।',
        title: {
          text1: 'विज्ञापन क्रिएटिव परीक्षण',
          text2: 'परीक्षण रिपोर्ट',
        },
        flowAnalysis: {
          desc1: 'AdEff आपके वीडियो विज्ञापन को विभाजित कर रहा है',
          desc2: 'वीडियो विभाजन पूरा हुआ',
          desc3: 'उपभोक्ता दृश्य ध्यान का विश्लेषण किया जा रहा है',
          desc4: 'उपभोक्ता प्रोफाइल के आधार पर दृश्य फोकस का विश्लेषण किया जा रहा है',
          desc5: 'ध्यान हीटमैप बनाया जा रहा है',
          desc6: 'डायनामिक हीटमैप बन गया',
          desc7: 'संज्ञानात्मक-न्यूरल प्रतिक्रियाएं मापी जा रही हैं',
          desc8: 'नज़र, भावना और सहभागिता को सेकंड-दर-सेकंड ट्रैक किया जा रहा है',
          desc9: 'न्यूरल प्रतिक्रिया वक्र बनाया जा रहा है',
          desc10: 'न्यूरल प्रतिक्रिया वक्र बन गया',
          desc11: 'मुख्य क्षणों में प्रदर्शन का विश्लेषण किया जा रहा है',
          desc12: 'गोल्डन 3 सेकंड, संदेश क्षण, ब्रांड क्षण, रुचि शिखर और अंतिम 3 सेकंड के दौरान संज्ञानात्मक-न्यूरल प्रतिक्रियाएं मापी जा रही हैं',
          desc13: 'मुख्य क्षण मेट्रिक्स का संश्लेषण किया जा रहा है',
          desc14: 'मुख्य क्षण विश्लेषण पूरा हुआ',
          desc15: 'उपभोक्ता दृष्टिकोणों का विश्लेषण किया जा रहा है',
          desc16: 'ब्रांड, उत्पाद और सामग्री के प्रति दृष्टिकोणों का विश्लेषण किया जा रहा है',
          desc17: 'दृष्टिकोण मेट्रिक्स का संश्लेषण किया जा रहा है',
          desc18: 'दृष्टिकोण मेट्रिक्स पूरे हुए',
          desc19: 'पांच प्रभाव कारक स्कोर बनाए जा रहे हैं',
          desc20: 'पांच प्रभाव कारक स्कोर तैयार हैं',
          desc21: 'विश्लेषण पूरा! आपकी विज्ञापन प्रदर्शन रिपोर्ट तैयार है',
          terminology: {
            thumbExpand: 'थंबनेल फैलाएँ',
            thumbCollapse: 'थंबनेल समेटें',
            gazeRecognition: 'नज़र पहचान',
            gazeRecognitionDesc: 'दृश्य ध्यान की एकाग्रता मापता है और बताता है कि विज्ञापन तत्व दर्शक का फोकस कितनी प्रभावी तरह पकड़ते हैं।',
            emotionRecognition: 'भावना पहचान',
            emotionRecognitionDesc: 'विज्ञापन से उत्पन्न सकारात्मक भावनाओं और तात्कालिक भावनात्मक प्रतिक्रियाओं को मापता है।',
            engagementRecognition: 'सहभागिता पहचान',
            engagementRecognitionDesc: 'डूबने और सहभागिता को मापता है, जो विज्ञापन सामग्री में मानसिक निवेश को दर्शाता है।',
            theGolden3Seconds: 'गोल्डन 3 सेकंड प्रदर्शन',
            theGolden3SecondsDesc: 'शुरुआती 3 सेकंड में विज्ञापन सामग्री की प्रभावशीलता का मूल्यांकन करता है।',
            keyMessage: 'मुख्य संदेश प्रदर्शन',
            keyMessageDesc: 'विज्ञापन सूचना क्षणों की ध्यान खींचने और रुचि जगाने की क्षमता को मापता है।',
            brand: 'ब्रांड प्रदर्शन',
            brandDesc: 'ब्रांड-विशिष्ट ध्यान पकड़ने और सहभागिता प्रभावशीलता का आकलन करता है।',
            interest: 'रुचि शिखर',
            interestDesc: 'भावनात्मक प्रतिध्वनि और उच्च सहभागिता उत्पन्न करने वाले सामग्री शिखरों की पहचान करता है।',
            ending3Seconds: 'अंतिम 3 सेकंड प्रदर्शन',
            ending3SecondsDesc: 'अंतिम 3 सेकंड में विज्ञापन सामग्री की प्रभावशीलता का मूल्यांकन करता है।',
            score: 'स्कोर',
            benchmark: 'बेंचमार्क',
            metrics: 'मेट्रिक्स',
            attitudePart: {
              attitudeMetrics: 'दृष्टिकोण मेट्रिक्स',
              liking: 'पसंद',
              likingDesc: 'विज्ञापन के प्रति दर्शकों के व्यक्तिपरक दृष्टिकोण और समग्र पसंद के स्तर को मापता है।',
              newInformation: 'नई जानकारी',
              newInformationDesc: 'मापता है कि दर्शक विज्ञापन से ब्रांड या उत्पाद के बारे में पहले अज्ञात, मूल्यवान जानकारी प्राप्त करने का अनुभव करते हैं या नहीं।',
              messageRelevance: 'संदेश प्रासंगिकता',
              messageRelevanceDesc: 'मापता है कि दर्शक विज्ञापन में दी गई जानकारी को अपने लिए सीधे संबंधित कितना मानते हैं।',
              comprehension: 'समझ',
              comprehensionDesc: 'मापता है कि विज्ञापन का मुख्य संदेश दर्शकों द्वारा स्पष्ट, सटीक और सहज रूप से समझा गया या नहीं।',
              credibility: 'विश्वसनीयता',
              credibilityDesc: 'मापता है कि दर्शक विज्ञापन में दी गई जानकारी को कितना सत्य, भरोसेमंद और विश्वसनीय मानते हैं।',
              brandLinkage: 'ब्रांड संबंध',
              brandLinkageDesc: 'मापता है कि दर्शक विज्ञापन को विशिष्ट ब्रांड से सही और मजबूत रूप से जोड़ पाते हैं या नहीं।',
              uniqueness: 'विशिष्टता',
              uniquenessDesc: 'मापता है कि विज्ञापन प्रतिस्पर्धियों की तुलना में ब्रांड की स्पष्ट और मूल्यवान विशिष्टता की धारणा स्थापित करता है या नहीं।',
              willing: 'और जानने की इच्छा',
              willingDesc: 'विज्ञापन देखने के बाद ब्रांड या उत्पाद के बारे में और जानने के लिए दर्शकों द्वारा सक्रिय कदम उठाने की व्यक्तिपरक संभावना को मापता है।',
              purchase: 'खरीद इरादा',
              purchaseDesc: 'विज्ञापन देखने के बाद भविष्य में ब्रांड उत्पाद चुनने या खरीदने पर विचार करने की व्यक्तिपरक संभावना को मापता है।',
              share: 'साझा करने योग्यता',
              shareDesc: 'विज्ञापन देखने के बाद विज्ञापन या ब्रांड जानकारी को दूसरों के साथ सक्रिय रूप से साझा करने की व्यक्तिपरक संभावना को मापता है।',
              brandLikeLift: 'ब्रांड पसंद वृद्धि',
              brandLikeLiftDesc: 'विज्ञापन देखने के बाद ब्रांड या उत्पाद के प्रति समग्र पसंद में परिवर्तन की दिशा और मात्रा को मापता है।',
              purchaseIntentLift: 'खरीद इरादा वृद्धि',
              purchaseIntentLiftDesc: 'विज्ञापन देखने के बाद ब्रांड उत्पाद खरीदने पर विचार करने की इच्छा में परिवर्तन की दिशा और मात्रा को मापता है।',
            },
            dimensionPart: {
              forceDrives: 'प्रभाव कारक',
              attension: 'ध्यान',
              emotionalImpact: 'भावनात्मक प्रभाव',
              messageClarity: 'संदेश स्पष्टता',
              brandPower: 'ब्रांड शक्ति',
              persuasion: 'प्रेरकता',
              attentionForce: 'ध्यान शक्ति',
              attentionForceDesc: 'दर्शकों का दृश्य और श्रव्य ध्यान आकर्षित और बनाए रखने की विज्ञापन की क्षमता को मापता है।',
              emotionalForce: 'भावनात्मक शक्ति',
              emotionalForceDesc: 'विज्ञापन सामग्री द्वारा उत्पन्न तात्कालिक, सहज भावनात्मक प्रतिध्वनि और उतार-चढ़ाव की तीव्रता को मापता है।',
              messageForce: 'संदेश शक्ति',
              messageForceDesc: 'लक्षित दर्शकों द्वारा विज्ञापन के मुख्य संदेश को स्पष्ट रूप से पहचानने, सही समझने और गहराई से याद रखने की प्रभावशीलता को मापता है।',
              brandForce: 'ब्रांड शक्ति',
              brandForceDesc: 'ब्रांड पहचान को मजबूत करने, ब्रांड पसंद बढ़ाने और मजबूत ब्रांड संबंध बनाने में विज्ञापन की प्रभावशीलता को मापता है।',
              persuasiveForce: 'प्रेरक शक्ति',
              persuasiveForceDesc: 'धारणाओं को बदलने और व्यवहारिक इरादों को प्रेरित करने की विज्ञापन की अंतिम क्षमता को मापता है।',
            },
            result: {
              results: 'परिणाम',
              pass: 'पास',
              notPass: 'पास नहीं',
              adeffScore: 'AdEff स्कोर',
              adeffScoreDesc: 'AdEff स्कोर विज्ञापनों की समग्र प्रभावशीलता मापने के लिए बनाया गया है।',
              benchmarkDesc: 'विज्ञापन जिस देश या क्षेत्र में है, वहाँ अपलोड किए गए सभी विज्ञापनों के औसत AdEff स्कोर का उपयोग उसके प्रदर्शन की तुलना के लिए किया जाता है।',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: 'प्रतीक्षा...',
            description: 'आपकी परीक्षण रिपोर्ट बनाई जा रही है...',
          },
          generating: 'बन रही है...',
          freeTrialLockText1:
            'ट्रायल मोड में पूरी रिपोर्ट का पूर्वावलोकन या डाउनलोड उपलब्ध नहीं है।',
          freeTrialLockText2: 'अनलॉक करने के लिए सदस्यता लें।',
        },
      },
    },
  },
  professor: {
    account: 'खाता',
    password: 'पासवर्ड',
    login: 'लॉगिन',
    expertReviews: 'विशेषज्ञ समीक्षाएँ',
    adVideoScore: 'विज्ञापन प्रभावशीलता सूचकांक',
    subjectiveResponseCurve: 'विषयगत प्रतिक्रिया वक्र',
    indexAnalysis: 'सूचकांक विश्लेषण',
    keyResult: 'मुख्य परिणाम',
    theGolden3Seconds: 'सोने के 3 सेकंड',
    informationTransmission: 'जानकारी क्षण',
    brandRelevance: 'ब्रांड क्षण',
    interestStimulation: 'रुचि क्षण',
    theEnding3Seconds: 'अंतिम 3 सेकंड',
    heatMap: 'हीटमैप',
    suggestion: 'सिफारिशें',
    suggestion1: 'सिफारिश',
    submit: 'जमा करें',
    next: 'अगाड़ा',
    summary: 'सारांश',
    advantages: 'लाभ',
    disadvantages: 'हानियाँ',
    option1: 'अपेक्षित',
    option2: 'अपेक्षित नहीं',
    resultJudgment: 'समीक्षा',
    placeholder: 'सिफारिश दर्ज करें',
    waitRateCount: 'आदेश करने वाले विज्ञापनों की संख्या',
    unfinishedTitle: 'सूचना',
    unfinishedRate: 'विज्ञापन में आवश्यक अंक भरे नहीं हैं',
    unfinishedConfirm: 'समीक्षा जारी रखें',
    unfinishedCancel: 'निर्गत होना',
    message: {
      submitSuccess: 'आपकी समीक्षा के लिए धन्यवाद',
      submitSuccess1: 'आपने इस परियोजना की समीक्षा पूरी कर ली है, धन्यवाद',
      loginSuccess: 'लॉगिन सफलतापूर्वक',
      rateUnfinished:
        'आपने अभी तक वर्तमान सामग्री का मूल्यांकन नहीं किया है, कृपया इसे भरने के बाद अगले प्रश्न पर जाएं',
      rateLocation: 'हमने आपके लिए आवश्यक अंक भरे नहीं हैं',
    },
  },
  modals: {
    freeTrialModal: {
      title: 'एक परीक्षण अनुरोध करें',
      title1: 'मुफ्त परीक्षण',
      trial: 'परीक्षण',
      hiddenBoxText1: 'कई लाभ, नुकसान और सुझाव पाए गए',
      hiddenBoxText2: 'पूर्ण रिपोर्ट प्राप्त करने के लिए सदस्यता लें',
      hiddenBoxBtn: 'सदस्यता लें अब',
      applyBox: {
        name: 'आपका नाम',
        tel: 'संपर्क नंबर',
        department: 'विभाग',
        role: 'भूमिका',
        country: 'देश',
        city: 'शहर',
        pleaseEnter: 'कृपया दर्ज करें',
        pleaseSelect: 'कृपया चुनें',
        pleaseEnterTheName: 'कृपया आपका नाम दर्ज करें',
        pleaseEnterTheTel: 'कृपया आपका संपर्क नंबर दर्ज करें',
        pleaseEnterValidTel: 'कृपया एक वैध संपर्क नंबर दर्ज करें',
        pleaseEnterValidEmail: 'कृपया एक वैध ईमेल दर्ज करें',
        pleaseSelectTheDepartment: 'कृपया आपका विभाग चुनें',
        pleaseSelectTheRole: 'कृपया आपकी भूमिका चुनें',
        pleaseSelectTheCountry: 'कृपया आपका देश चुनें',
        pleaseEnterTheCity: 'कृपया आपका शहर दर्ज करें',
        textIsRequired: 'यह फ़ील्ड आवश्यक है',
        submit: 'जमा करें',
        tip: 'प्रत्येक कंपनी के लिए केवल एक मुफ्त परीक्षण अवसर है',
      },
      gotTrial: 'आपको एक परीक्षण मिला है!',
      goPc: 'कृपया पीसी वेब संस्करण पर जाएं और अपनी परियोजना बनाएं।',
      back: 'वापस जाएं',
      country: {
        China: 'चीन',
        Japan: 'जापान',
        Korea: 'कोरिया',
        Indonesia: 'इंडोनेशिया',
        Thailand: 'थाईलैंड',
        Singapore: 'सिंगापुर',
        Malaysia: 'मलेशिया',
        Vietnam: 'वियतनाम',
        Germany: 'जर्मनी',
        Britain: 'ब्रिटेन',
        France: 'फ्रांस',
        Italy: 'इटली',
        Russia: 'रूस',
        Spain: 'स्पेन',
        Turkey: 'तुर्की',
        America: 'अमेरिका',
        Canada: 'कनाडा',
        Brazil: 'ब्राज़ील',
        Other: 'अन्य',
      },
      department: {
        Brand: 'ब्रांड',
        Market: 'बाजार',
        Marketing: 'विपणन',
        IT: 'टीएस',
        Procurement: 'खरीद',
        Other: 'अन्य',
      },
      role: {
        President: 'राज्यपाल/विधायक/व्यवस्थापक',
        CMO: 'CMO या अन्य C-level प्रबंधन',
        Director: 'विभाग अध्यक्ष',
        Manager: 'विभाग प्रबंधक',
        Other: 'अन्य',
      },
      message: {
        submitSuccess: 'आपकी समीक्षा के लिए धन्यवाद',
        submitFailed: 'आपकी समीक्षा के लिए धन्यवाद',
      },
    },
    downloadPptRechargeModal: {
      title: 'रिपोर्ट डाउनलोड नहीं किया जा सकता',
      desc1: 'परीक्षण संस्करण में रिपोर्ट डाउनलोड नहीं किया जा सकता',
      desc2: 'पूर्ण रिपोर्ट प्राप्त करने के लिए सदस्यता लें',
      btn: 'सदस्यता लें अब',
    },
    checkInvitationCodeModal: {
      invitationCode: 'रेफरल कोड',
      invitationCodeDesc1:
        'रेफरल कोड बदला नहीं जा सकता, यदि आप इसे बदलना चाहते हैं, तो कृपया हमसे संपर्क करें',
      invitationCodeDesc2:
        'यदि आप एजेंट रेफरल के माध्यम से इसका उपयोग कर रहे हैं, तो कृपया रेफरल कोड दर्ज करें',
      invitationCodePlaceholder: 'कृपया रेफरल कोड दर्ज करें',
      invitationCodeError: 'अमान्य रेफरल कोड',
      invitationCodeSuccess: 'रेफरल कोड सफलतापूर्वक बदल दिया गया',
      ok: 'ठीक है',
      cancel: 'रद्द करें',
    },
    aigcPromotionModal: {
      title: 'AIGC क्रिएटर लाभ',
      subTitle: 'अभी रजिस्टर करें और <tmp>5</tmp> AI वीडियो मूल्यांकन अवसर पाएं',
      desc1: 'अपने क्रिएटिव्स का मूल्यांकन करने के लिए AdEff AI Creative Testing इवेंट से जुड़ें।',
      desc2: 'अभी रजिस्टर करें और तुरंत 5 मुफ्त टेस्ट पाएं।',
      registerBtn: 'टेस्ट अवसर पाने के लिए रजिस्टर करें',
      tip: 'केवल उन नए उपयोगकर्ताओं के लिए जो AIGC क्रिएटर अभियान प्रवेश से रजिस्टर करते हैं',
      floatTitle: 'निःशुल्क परीक्षण',
    },
  },
}

export default TRANSLATION
